<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    import { Icon } from '@oat-sa-private/ui-elements';
    import { getActualKey, __ } from '@oat-sa-private/ui-core';
    import { createEventDispatcher } from 'svelte';
    export let data;

    const dispatch = createEventDispatcher();

    /**
     * Keypress handler
     * @param {KeyboardEvent} event keyboard event
     * @fires keyboardorder
     */
    function handleKeydown(event) {
        const key = getActualKey(event);
        if (key === 'enter' || key === 'space') {
            event.stopPropagation();
            dispatch('action', { type: 'keyboardorder', options: { index: data.index } });
        }
    }
</script>

<style>
    button.drag-button {
        width: 3rem;
        height: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
        border: none;

        @add-mixin outline-focus 0;

        &:focus-visible::after {
            border-color: var(--color-border-actionable-hover);
        }
    }
</style>

<button
    class="drag-button"
    aria-label={__('Press enter or space to select the row to reorder')}
    on:keydown={handleKeydown}>
    <Icon name="draggable-16" />
</button>
